import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";

// const appConfig = window.__env.configs["appConfig"];
let interval = setInterval(() => {
  const appConfig = window?.__env?.configs["appConfig"];
  if (appConfig) {
    clearInterval(interval); // Stop the interval once appConfig is loaded
    // You can add further logic here if needed
    mainExecution(appConfig)
  }
}, 300);

const mainExecution = (appConfig) => {
  let PI_CLIENT_ID;
  if(appConfig["ENV"] === "PROD"){
    PI_CLIENT_ID = "HYkFyFYDBhd31gndan2gbVKoO5jkBGZK";
  } else {
    PI_CLIENT_ID = "04tPBMFTxFizhfW3uBMlAx662hZFePSH";
  }

  const importMap = {
    imports: {
      "single-spa": "https://cdn.jsdelivr.net/npm/single-spa@5.9.0/lib/system/single-spa.min.js",
      "react": "https://cdn.jsdelivr.net/npm/react@17.0.2/umd/react.production.min.js",
      "react-dom": "https://cdn.jsdelivr.net/npm/react-dom@17.0.2/umd/react-dom.production.min.js",
      "jquery": "https://cdn.jsdelivr.net/npm/jquery@3.6.0/dist/jquery.min.js",
      "@pearson/ead-header-navbar": appConfig["MFE_URLS"].HEADER_URL,
      "@pearson/ead-footer": appConfig["MFE_URLS"].FOOTER_URL,
      "@pearson/ead-core": appConfig["MFE_URLS"].CORE_URL,
      "@pearson/ead-lti-1-3": appConfig["MFE_URLS"].LTI13_URL,
      "@pearson/root-config": appConfig["MFE_URLS"].CONFIG_URL
    }
  };
  const importMapScript = document.createElement("script");
  importMapScript.type = "systemjs-importmap";
  importMapScript.textContent = JSON.stringify(importMap, null, 2);
  document.head.appendChild(importMapScript);

  let piSessionScript = document.createElement("script");
  piSessionScript.src = appConfig["PI_API"];
  document.body.appendChild(piSessionScript);
  
  let inputPiUserId = document.createElement("input");
  inputPiUserId.type = "hidden";
  inputPiUserId.id = "pi_user_id";
  document.body.appendChild(inputPiUserId);
  let isApplicationStart = false;
  
  const loadApplication = () => {
    let data = {
      props: {
        env: appConfig["ENV"],
        userId: window?.piSession?.userId(),
        userToken: window?.piSession?.currentToken()
      },
    };
    const routes = constructRoutes(microfrontendLayout, data);
    
    const applications = constructApplications({
      routes,
      loadApp({ name }) {
        if (name === "@pearson/ead-footer") {
          return System.import(appConfig["MFE_URLS"].FOOTER_URL);
        }
        else if (name === "@pearson/ead-header-navbar") {
          return System.import(appConfig["MFE_URLS"].HEADER_URL);
        }
        else if (name === "@pearson/ead-core") {
          return System.import(appConfig["MFE_URLS"].CORE_URL);
        }
        else if (name === "@pearson/ead-lti-1-3") {
          return System.import(appConfig["MFE_URLS"].LTI13_URL);
        } 
        else if (name === "@pearson/root-config") {
          return System.import(appConfig["MFE_URLS"].CONFIG_URL);
        }
        else {
          return System.import(name);  
        }
        
      },
    });
  
    const layoutEngine = constructLayoutEngine({ routes, applications }); 
  
    applications.forEach(registerApplication);
    layoutEngine.activate();
    start();
    isApplicationStart = true;  
  };

function redirectHandle(path){
  let pathName;
  if(path && path !== '/'){
    pathName = path;
  }else{
    pathName = '/institution';
  }

  return pathName;
}

function startPiSession() {
    let session = window.piSession;
    if (!session) return console.error("piSession did not load!");
    window.piSession.initialize(PI_CLIENT_ID, {
      sessionIdleTimeoutSeconds: 1800,
    });

    window.piSession.on(window.piSession.RefreshEvent, function (eventData) {
      if (session.hasValidSession(10) !== "success") {
        let params = new URLSearchParams(window.location.search);
        window.piSession.login(
          `${window.location.origin}${
            redirectHandle(window.location.pathname)
          }?${params.toString()}`
        );
      } else {
        if (!isApplicationStart) {
          loadApplication();  
        }
        
      }
    });

    session.on(session.SessionStateKnownEvent, function () {
      if (session.hasValidSession(10) !== "success") {
        let params = new URLSearchParams(window.location.search);
        window.piSession.login(
          `${window.location.origin}${
            redirectHandle(window.location.pathname)
          }?${params.toString()}`
        );
      }

      session.on(session.LoginEvent, function () {
        if (session.hasValidSession(10) === "success") {
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        }
      });

      session.on(session.LogoutEvent, function () {
        let params = new URLSearchParams(window.location.search);
        window.piSession.login(
          `${window.location.origin}${
            redirectHandle(window.location.pathname)
          }?${params.toString()}`
        );
      });
      
    });
  }
  piSessionScript.onload = startPiSession;
} 